import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Store } from '@ngrx/store';
import * as fromAuthActions from '../store/actions/auth.actions';
import { distinctUntilChanged } from 'rxjs/operators';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(fb, router, toastr, store) {
        this.fb = fb;
        this.router = router;
        this.toastr = toastr;
        this.store = store;
    }
    LoginComponent.prototype.ngOnInit = function () {
        this.createLoginForm();
    };
    LoginComponent.prototype.createLoginForm = function () {
        this.loginForm = this.fb.group({
            email: ['', Validators.required],
            password: ['', Validators.required]
        });
    };
    LoginComponent.prototype.userLoginAction = function () {
        var _this = this;
        this.store.dispatch(new fromAuthActions.LoginUser(this.loginForm.value));
        this.store.select(function (s) { return s.auth; }).pipe(distinctUntilChanged(function (a) { return (a.error !== null); })).subscribe(function (res) {
            if (res.loggedIn) {
                _this.router.navigate(['/freelancers']);
            }
            else if (!!res.error) {
                _this.toastr.error(res.error);
            }
        });
    };
    return LoginComponent;
}());
export { LoginComponent };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/login/login.component.ts.pre-build-optimizer.js